<template>
  <b-modal
    id="notesForm-modal"
    ref="notesForm_modal"
    :title="note && !note.id ? 'Dodaj notatkę' : 'Edytuj Notatkę'"
    @hidden="onClose"
    @show="onShow"
  >
    <ValidationObserver
      ref="noteformValidation"
      tag="form"
      @submit.prevent="onSubmit"
      id="noteform"
    >
      <b-form-group label="Autor wpisu:" label-for="autor">
        <b-form-input
          id="autor"
          class="title-input"
          :value="autorName"
          type="text"
          disabled="disabled"
          style="font-size: 0.9rem"
        ></b-form-input>
      </b-form-group>

      <ValidationProvider
        name="content"
        rules="required|min:2"
        v-slot="validationContext"
      >
        <b-form-group label="Treść wpisu:" label-for="content">
          <b-form-textarea
            id="content"
            v-model="form.content"
            placeholder="Wpisz notke..."
            rows="3"
            max-rows="6"
          ></b-form-textarea>
          <b-form-invalid-feedback
            :state="getValidationState(validationContext)"
            >{{ validationContext.errors[0] }}</b-form-invalid-feedback
          >
        </b-form-group>
      </ValidationProvider>
    </ValidationObserver>
    <template v-slot:modal-footer="{ cancel }">
      <b-button size="md" variant="primary" type="submit" form="noteform"
        >Zapisz</b-button
      >
      <b-button size="md" variant="outline-danger" @click="cancel()"
        >Anuluj</b-button
      >
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import notesService from "@/services/notes.service";

export default {
  name: "NotesModalForm",
  props: {
    note: { type: Object },
    constructionid: { type: Number },
  },
  data() {
    return {
      form: {
        content: "",
      },
    };
  },
  computed: {
    ...mapGetters("user", ["getFullName", "isNotSubcontractor"]),
    autorName() {
      return (this.note && this.note.fullname) || this.getFullName;
    },
  },
  methods: {
    getValidationState({ validated, valid = null }) {
      return validated ? valid : null;
    },
    onShow() {
      this.form.content = this.note.content;
    },
    onSubmit() {
      this.$refs.noteformValidation.validate().then((success) => {
        if (!success) {
          return;
        }
        this.$Progress.start();
        if (!this.note || !this.note.id) {
          notesService.add(this.constructionid, this.form).then((newNote) => {
            this.$emit("onSubmit", newNote);
            this.$nextTick(() => {
              this.$bvModal.hide("notesForm-modal");
            });
          });
        } else {
          notesService.update(this.constructionid, this.note.id, this.form)
            .then(() => {
              this.note.content = this.form.content;
              this.$nextTick(() => {
                this.$bvModal.hide("notesForm-modal");
              });
            });
        }
      });
    },
    onClose() {
      this.$emit("onClose");
    },
    cancel() {
      this.onClose();
    },
  },
};
</script>
